import React, { useEffect } from 'react';

const MapaComposto = ({ setCurrentPage }: { setCurrentPage: Function; }) => {

    useEffect(() => {
        setCurrentPage(window.location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="card-body overflow-hidden h-100" >
                                <button type="button" className="btn btn-danger m-3 position-absolute" data-bs-dismiss="modal">Fechar</button>
                                <div className="d-flex h-50">
                                    <div className="card-body p-1">
                                        <iframe width="100%" height="100%" title='TopLeft'
                                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=wind&product=ecmwf&level=surface&lat=-7.338&lon=-35.228&detailLat=-7.094&detailLon=-35.228&detail=true">
                                        </iframe>
                                    </div>
                                    <div className="card-body p-1">
                                        <iframe width="100%" height="100%" title='TopRight'
                                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=7&overlay=satellite&product=satellite&level=surface&lat=-7.26&lon=-35.389&detailLat=-7.094&detailLon=-35.228&marker=true">
                                        </iframe>
                                    </div>
                                </div>
                                <div className="d-flex h-50">
                                    <div className="card-body p-1">
                                        <iframe width="100%" height="100%" title='BotLeft'
                                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=temp&product=ecmwf&level=surface&lat=-7.135&lon=-35.199">
                                        </iframe>
                                    </div>
                                    <div className="card-body p-1">
                                        <iframe width="100%" height="100%" title='BotRight'
                                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=radar&product=radar&level=surface&lat=-7.135&lon=-35.199">
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card m-2 vh-100">
                <div className="card-header d-flex justify-content-between text-center align-items-end">
                    <div></div>
                    <h5 className="text-center">
                        Mapa Composto
                    </h5>
                    <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <i className="bi bi-arrows-angle-expand"></i>
                    </button>
                </div>
                <div className="d-flex h-50">
                    <div className="card-body p-1">
                        <iframe width="100%" height="100%" title='TopLeft'
                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=wind&product=ecmwf&level=surface&lat=-7.338&lon=-35.228&detailLat=-7.094&detailLon=-35.228&detail=true">
                        </iframe>
                    </div>
                    <div className="card-body p-1">
                        <iframe width="100%" height="100%" title='TopRight'
                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=7&overlay=satellite&product=satellite&level=surface&lat=-7.26&lon=-35.389&detailLat=-7.094&detailLon=-35.228&marker=true">
                        </iframe>
                    </div>
                </div>
                <div className="d-flex h-50">
                    <div className="card-body p-1">
                        <iframe width="100%" height="100%" title='BotLeft'
                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=temp&product=ecmwf&level=surface&lat=-7.135&lon=-35.199">
                        </iframe>
                    </div>
                    <div className="card-body p-1">
                        <iframe width="100%" height="100%" title='BotRight'
                            src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=radar&product=radar&level=surface&lat=-7.135&lon=-35.199">
                        </iframe>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MapaComposto;
